// statsCounter JS, for animating number counts in new theme
// datarobot6/views/gutenberg/content/dr-stats-module.twig
// datarobot6/views/gutenberg/content/dr-stats-module-light.twig

document.addEventListener("DOMContentLoaded", () => {
	// Function to animate counting up for integers and decimals
	function animateCountUp(element, targetValue, duration = 2000) {
		let startValue = 0;
		let startTime = null;

		// Determine if the target value is a decimal
		const isDecimal = targetValue % 1 !== 0;

		function step(timestamp) {
			if (!startTime) startTime = timestamp;
			const progress = Math.min((timestamp - startTime) / duration, 1);
			const currentValue = startValue + progress * (targetValue - startValue);

			// Format the number: decimals keep 1 digit, integers are rounded
			element.textContent = isDecimal ? currentValue.toFixed(1) : Math.floor(currentValue).toLocaleString();

			if (progress < 1) {
				requestAnimationFrame(step);
			} else {
				// Ensure the final value is accurate
				element.textContent = isDecimal ? targetValue.toFixed(1) : targetValue.toLocaleString();
			}
		}

		requestAnimationFrame(step);
	}

	// Set up IntersectionObserver to trigger the animation when visible
	const observerOptions = {
		root: null,
		rootMargin: "0px",
		threshold: 0.3, // Trigger when 30% visible
	};

	// One-time animation observer for statsModule
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const counter = entry.target;
				const targetValue = parseFloat(counter.textContent.replace(/,/g, ""));

				if (!isNaN(targetValue) && !counter.classList.contains("counted")) {
					animateCountUp(counter, targetValue);
					counter.classList.add("counted");
				}

				observer.unobserve(counter);
			}
		});
	}, observerOptions);

	// Target all statsModule counters (one-time animation)
	const counters = document.querySelectorAll(".statsModule__statsCounter");
	counters.forEach((counter) => {
		observer.observe(counter);
	});

	// Repeating animation observer for solutionsData
	const repeatObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const counter = entry.target;

			if (entry.isIntersecting) {
				// Store original value on first observation
				if (!counter.dataset.targetValue) {
					counter.dataset.targetValue = counter.textContent.replace(/,/g, "");
				}
				const targetValue = parseFloat(counter.dataset.targetValue);

				if (!isNaN(targetValue)) {
					animateCountUp(counter, targetValue);
				}
			} else {
				// Reset to 0 when out of view so animation replays on next scroll
				if (counter.dataset.targetValue) {
					counter.textContent = "0";
				}
			}
		});
	}, observerOptions);

	// Target all solutionsData counters (repeating animation)
	const solutionsDataCounters = document.querySelectorAll(".solutionsData__cardStatValue");
	solutionsDataCounters.forEach((counter) => {
		repeatObserver.observe(counter);
	});
});
